// extracted by mini-css-extract-plugin
module.exports = {"main":"Description_main__bmFlI","title":"Description_title__kCPpy"};